import { render } from "./parcours.vue?vue&type=template&id=cb938508&scoped=true"
import script from "./parcours.vue?vue&type=script&lang=js"
export * from "./parcours.vue?vue&type=script&lang=js"

import "./parcours.vue?vue&type=style&index=0&id=cb938508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb938508"]])

export default __exports__